import { motion } from "framer-motion";
import { TrendingUp, TrendingDown } from "lucide-react";
import { PriceCardSkeleton } from "@/components/Skeletons";

function fmt(v) {
  const d = v >= 1000 ? 0 : v >= 1 ? 2 : 4;
  return v.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
}

export default function LivePriceStrip({ prices, loading, onOpen }) {
  if (loading) {
    return (
      <div className="no-scrollbar flex gap-3 overflow-x-auto px-4 pb-1">
        {[0, 1, 2].map((i) => <PriceCardSkeleton key={i} />)}
      </div>
    );
  }
  return (
    <div className="no-scrollbar flex gap-3 overflow-x-auto px-4 pb-1">
      {prices.map((p, i) => {
        const up = p.change_pct >= 0;
        return (
          <motion.button
            key={p.symbol}
            initial={{ opacity: 0, x: 24 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: Math.min(i * 0.04, 0.3) }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onOpen?.(p.symbol)}
            data-testid={`price-card-${p.symbol}`}
            className="goe-card shrink-0 p-4 text-left"
            style={{ width: 176 }}
          >
            <div className="flex items-center justify-between">
              <span className="line-clamp-1 text-sm font-semibold text-dim">{p.name}</span>
              <span className="flex items-center gap-0.5 text-xs font-bold"
                    style={{ color: up ? "var(--green)" : "var(--red)" }}>
                {up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                {up ? "+" : ""}{p.change_pct}%
              </span>
            </div>
            <div className="mt-2 font-display text-2xl font-extrabold" style={{ color: "var(--text)" }}>
              ${fmt(p.price)}
            </div>
            <div className="mt-0.5 text-xs text-dim">{p.unit}</div>
          </motion.button>
        );
      })}
    </div>
  );
}
